export default __webpack_public_path__ + "static/media/BrainBreak cards43.96625e60.png";